export default __webpack_public_path__ + "static/media/newSet1-1-min.f7ed9c89.png";